import { Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const getWedding = generateAPI<{}, Wedding>("get", "wedding/");
